<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :style="iconSizeStyle(size)"
    viewBox="0 0 21.4746 16"
    fill="none"
    aria-hidden="true"
    class="g-icon-eye"
  >
    <path
      d="M10.7373 0C17.1023 4.99468e-05 20.0196 4.09879 21.1113 6.29004C21.1594 6.38662 21.2261 6.51729 21.2852 6.69043C21.3423 6.858 21.3847 7.03968 21.4268 7.26465C21.4662 7.47568 21.4746 7.78141 21.4746 8C21.4746 8.21859 21.4662 8.52432 21.4268 8.73535C21.3847 8.96032 21.3423 9.142 21.2852 9.30957C21.2261 9.48271 21.1594 9.61338 21.1113 9.70996C20.0196 11.9012 17.1023 16 10.7373 16C4.37226 16 1.45404 11.9012 0.362305 9.70996C0.314202 9.61342 0.248393 9.4825 0.189453 9.30957C0.13236 9.14201 0.0899266 8.96032 0.0478516 8.73535C0.00838357 8.52432 0 8.2186 0 8C1.20765e-08 7.7814 0.0083836 7.47568 0.0478516 7.26465C0.0899266 7.03968 0.13236 6.85799 0.189453 6.69043C0.248393 6.5175 0.314202 6.38658 0.362305 6.29004C1.45404 4.09878 4.37226 0 10.7373 0ZM10.7373 2C5.43982 2 3.07093 5.33998 2.15332 7.18164C2.10141 7.28583 2.09226 7.30591 2.08203 7.33594C2.06985 7.37177 2.0484 7.44621 2.01367 7.63184C2.01583 7.62034 2.01042 7.64929 2.00586 7.73535C2.00185 7.81102 2 7.90358 2 8C2 8.09642 2.00185 8.18898 2.00586 8.26465C2.01042 8.35071 2.01583 8.37966 2.01367 8.36816C2.0484 8.55379 2.06985 8.62823 2.08203 8.66406C2.09226 8.69409 2.10141 8.71417 2.15332 8.81836C3.07093 10.66 5.43982 14 10.7373 14C16.0348 14 18.4037 10.66 19.3213 8.81836C19.3732 8.71417 19.3823 8.69409 19.3926 8.66406C19.4048 8.6282 19.4262 8.5537 19.4609 8.36816C19.4588 8.37977 19.4632 8.35078 19.4678 8.26465C19.4718 8.18898 19.4746 8.09642 19.4746 8C19.4746 7.90358 19.4718 7.81102 19.4678 7.73535C19.4632 7.64922 19.4588 7.62023 19.4609 7.63184C19.4262 7.4463 19.4048 7.3718 19.3926 7.33594C19.3823 7.30591 19.3732 7.28583 19.3213 7.18164C18.4037 5.34001 16.0348 2.00005 10.7373 2ZM12.7373 8C12.7373 6.89547 11.8418 6.00006 10.7373 6C9.63274 6 8.7373 6.89543 8.7373 8C8.7373 9.10457 9.63274 10 10.7373 10C11.8418 9.99994 12.7373 9.10453 12.7373 8ZM14.7373 8C14.7373 10.2091 12.9464 11.9999 10.7373 12C8.52817 12 6.7373 10.2091 6.7373 8C6.7373 5.79086 8.52817 4 10.7373 4C12.9464 4.00006 14.7373 5.7909 14.7373 8Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
import { iconSizeStyle } from '~/utils/iconSize'

withDefaults(defineProps<{ size?: number | string }>(), {
  size: 20
})
</script>

<style scoped>
.g-icon-eye {
  display: block;
  flex-shrink: 0;
  color: inherit;
}
</style>
